import { render, staticRenderFns } from "./AssignUsers.vue?vue&type=template&id=95ec3922"
import script from "./AssignUsers.vue?vue&type=script&lang=js"
export * from "./AssignUsers.vue?vue&type=script&lang=js"
import style0 from "./AssignUsers.vue?vue&type=style&index=0&id=95ec3922&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports